import axios from 'axios';

const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api').replace(/\/$/, '');

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('userToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Enhanced error handling for WAF/Proxy HTML responses
    if (error.response) {
      const contentType = error.response.headers['content-type'] || '';

      // If we get an HTML response (likely from Cloudflare/WAF) instead of JSON
      if (contentType.includes('text/html') || contentType.includes('text/plain')) {
        console.error('Received non-JSON error response (likely WAF):', error.response.status);

        // Attempt to create a standard error format for the UI
        if (!error.response.data || typeof error.response.data !== 'object') {
          error.response.data = {
            message: 'error_network_security', // New key to add to translations
            originalError: error.message
          };
        }
      }

      if (error.response.status === 401) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// Auth services
export const authService = {
  signup: (userData) => api.post('/auth/signup', userData),
  login: (credentials) => api.post('/auth/login', credentials),
};

export default api;